export default "__VITE_ASSET__UJ4AA_le__"